
export default {
  async asyncData({ $content, app, error, params }) {
    try {
      const page = await $content(
        `pages/${app.i18n.locale}/${params.slug}`
      ).fetch()

      return {
        page
      }
    } catch (e) {
      console.log(e)
      error({
        statusCode: 404
      })
    }
  },
  head() {
    const i18nSeo = this.$nuxtI18nSeo()
    return {
      ...i18nSeo,
      title: this.page.title
    }
  }
}
